import { styled } from '@material-ui/core';

// Apparently overriding BackstageSidebarDivider breaks the style of it completly.
// See and follow: https://github.com/backstage/backstage/issues/15427.
// There was an RFC to fix this: https://github.com/backstage/backstage/issues/16693,
// but it breaks existing components so it is not planned as of yet.
// Best we go forward with our own divider.
export const PuzzleSidebarDivider = styled('hr')(({ theme }) => ({
  height: 1,
  width: '100%',
  background: theme.palette.primary.dark,
  border: 'none',
  margin: theme.spacing(1.2, 0),
}));
